/**
 * Public site origin for absolute SEO URLs (canonical links, JSON-LD `url` fields).
 *
 * Reads VITE_SITE_URL (set per environment in .env.* and the release pipeline) and
 * falls back to the production origin so a missing variable never yields a relative
 * canonical. Trailing slashes are stripped so callers can append a root-relative path.
 */

/** Canonical production origin — also the value vite-plugin-seo treats as "production". */
export const PUBLIC_SITE_URL_FALLBACK = 'https://www.scheduledsmiles.com';

/**
 * Returns the configured public site origin without a trailing slash.
 */
export function getPublicSiteUrl(): string {
  const configured = (import.meta.env.VITE_SITE_URL as string | undefined)?.trim();
  const origin = configured && configured.length > 0 ? configured : PUBLIC_SITE_URL_FALLBACK;
  return origin.replace(/\/+$/, '');
}

/**
 * Builds the absolute canonical URL for a root-relative public path ('/' -> origin + '/').
 */
export function buildPublicAbsoluteUrl(path: string): string {
  const origin = getPublicSiteUrl();
  return path === '/' ? `${origin}/` : `${origin}${path}`;
}
